import {
  pickAssistantMessageMetaFromResult,
  resolveThoughtSummaryWithDuration,
} from '@/services/chatApi'

/** @param {unknown[]} list @param {string} pendingId @param {import('@/services/chatApi').ChatCompletionResult} result */
export function patchPendingFromCompletion(list, pendingId, result) {
  const idx = list.findIndex((msg) => msg.id === pendingId)
  if (idx === -1) return null
  const next = [...list]
  const textOut = result.ok ? result.text : `Could not get a reply.\n\n${result.message}`
  const assistantMeta = result.ok ? pickAssistantMessageMetaFromResult(result) : {}
  const prevRow = list[idx]
  const blocksFromApi =
    result.ok && Array.isArray(result.blocks) && result.blocks.length ? result.blocks : null
  next[idx] = {
    ...next[idx],
    text: textOut,
    createdAt: Date.now(),
    ...assistantMeta,
    ...(result.ok
      ? { thoughtSummary: resolveThoughtSummaryWithDuration(prevRow, assistantMeta) }
      : {}),
    ...(blocksFromApi ? { blocks: blocksFromApi } : {}),
  }
  return next
}
